import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-alert-full",
  templateUrl: "./med-icon-alert-full.component.html",
})
export class MedIconAlertFullComponent extends SvgMixinComponent {}
